const AUTH_EXPIRED_EVENT = 'auth:expired'

const authEventTarget = new EventTarget()

let authExpiredEmitted = false

export function emitAuthExpired(payload = {}) {
  if (authExpiredEmitted) return
  authExpiredEmitted = true
  authEventTarget.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT, { detail: payload }))
  setTimeout(() => {
    authExpiredEmitted = false
  }, 1000)
}

export function onAuthExpired(handler) {
  const listener = (e) => handler?.(e?.detail || {})
  authEventTarget.addEventListener(AUTH_EXPIRED_EVENT, listener)
  return () => authEventTarget.removeEventListener(AUTH_EXPIRED_EVENT, listener)
}

